<div class="flex flex-col w-full h-full">
  <div class="flex justify-between items-center lg:pt-2 sm:pt-0.5">
    <div class="flex items-center">
      <div>
        <span class="text-base font-medium text-white">
          {{ "today_alerts_title" | translate }}</span
        >
      </div>

      <img
        src="../../../../assets/images/info-icon.svg "
        class="w-full h-full ml-2 hidden"
        alt="Info"
      />
    </div>
    <div>
      <a
        class="text-white font-normal text-sm no-underline"
        [routerLink]="['../../', 'alerts', alertType]"
        >{{ "today_alerts_more_details" | translate }}</a
      >
    </div>
  </div>
  <div
    class="flex lg:flex-col sm:flex-row maincontent flex-grow justify-center md:pt-10 lg:pt-0 items-center md:w-full"
  >
    <div
      class="flex justify-center items-center flex-grow chart-part sm:w-fit sm:h-fit md:h-fit md:w-fit lg:h-unset lg:w-full"
    >
      <div
        echarts
        [options]="options!"
        class="lg:h-48 xxl:h-52 lg:w-[98%] sm:w-40 sm:h-40 md:w-30 md:h-30 md:w-30 sm:flex sm:items-center chart"
      ></div>
    </div>
    <div class="flex-grow"></div>
    <div
      class="flex flex-grow justify-between px-2 lg:w-full lg:items-center lg:h-fit lg:pt-0 lg:justify-between sm:flex-col md:flex-col lg:flex-row text-white secmaincontent"
    >
      <div
        class="flex flex-col lg:h-full ccone sm:h-fit lg:pt-0 ml-1 sm:-mt-2 md:-mt-2 lg:-mt-0"
      >
        <div>
          <img src="../../../../assets/svg/normal_alerts.svg" alt="alerts"/>

          <span class="text-[20px] ml-2">{{ alertsDetails.normalAlerts }}</span>
        </div>
        <div class="h-fit w-full">
          <span class="text-base text-dark-gray-content text-wrap"
            >Normal Alerts in

            {{ alertsDetails.normalAlertsPlantCount }} Plants
          </span>
        </div>
      </div>
      <div class="flex flex-col lg:h-full ccone sm:h-fit sm:mt-14 lg:mt-0 ml-1">
        <div>
          <img src="../../../../assets/svg/abnormal-alerts.svg" alt="alerts"/>

          <span class="text-[20px] ml-2">{{
            alertsDetails.abnormalAlerts
          }}</span>
        </div>
        <div class="h-fit w-full">
          <span class="text-base text-dark-gray-content text-wrap"
            >Abnormal Alerts in
            {{ alertsDetails.abnormalAlertsPlantCount }} Plants</span
          >
        </div>
      </div>
    </div>
  </div>
</div>
